import React from 'react';
import _ from 'lodash';
import renderIf from '../../../pkgs/render_if';
import $ from 'jquery';

import {
  FormControl,
  HelpBlock,
} from 'react-bootstrap';

export default class SelectAwesomplete extends React.Component {

  constructor(props){
    super(props);
    let value = {};
    value[this.props.data_key] = '';
    this.state = {
      label: '',
      dataList: null,
      ajax_json_response: null,
      loading: true,
      errors: '',
      touched_and_blank: '',
      value: value,
      placeholder: '',
      data:{},
    };
  }

  componentDidMount(){
    //console.log('componentdidmount select awesomplete displayInstance[data_key]');
    if (this.props.displayInstance) {
        //console.log(this.props.displayInstance[this.props.data_key]);
        if (this.props.displayInstance[this.props.data_key]) {
            this.setState({label: this.props.displayInstance[this.props.data_key]});
        }
    }
    this.loadAwesompleteAJAXJSONResponse();
  }

  loadAwesompleteAJAXJSONResponse = () => {
    let app_label = this.props.app_label;
    let model_name = this.props.model_name;
    $.ajax({
        url: '/api/awesomplete/' + app_label + '/' + model_name + '/',
        dataType: 'json',
        cache: false,
        success: (data) => {
          let input = document.getElementById(`${this.props.data_key}`);
          if (input) {
              var awesomplete = new Awesomplete(input, {
                maxItems: 10500,
                minChars: 0,
                list: data,
                replace: this.onReplace(input),
              });
              $(`#${this.props.data_key}`).on('focus', function() {
                awesomplete.evaluate();
              });
          }
          // if (this.props.field_value != undefined) {
          //   let this_value = this.props.field_value;
          //   this.props.onSelectChange(this.props.data_key, this_value);
          //   let value = this.state.value;
          //   value[this.props.data_key] = this_value;
          //   //this.props.onHandleSuccess(this.props.data_key);
          //   let instance = $.extend({}, data.filter(function(x) {
          //       return String(x.value) == String(this_value);
          //   })[0]);
          //   this.setState({
          //     label: instance.label,
          //     value: value,
          //     touched_and_blank: false,
          //   });
          // }
        }
    });
  }

  onReplace = (input) => {
    return ((item) => {
      this.props.onSelectChange(this.props.data_key, item.value, item.label);
      let value = this.state.value;
      value[this.props.data_key] = item.value;
      //this.props.onHandleSuccess(this.props.data_key);
      this.setState({
        label: item.label,
        value: value,
        touched_and_blank: false,
      });
    });
  }

  onChange = (event) => {
    let value  = this.state.value;
    value[this.props.data_key] = event.target.value;
    this.setState({
      label: event.target.value,
      touched_and_blank: false,
      value: value,
    });
  }

  handleBlur = () => {
    let data_key = this.props.data_key;
    let value = this.state.value[data_key];
    // if (this.props.field_required === true && !value) {
    //   this.props.onHandleErrors(data_key);
    //   this.setState({touched_and_blank: true, class_names: 'error'});
    // }
  }

  render() {
    let placeholder = this.state.placeholder;
    let style = {
      minHeight: 50,
      paddingTop: '0px !important',
      paddingBottom: '0px !important',
      width: '100%',
      border: '1px solid #ccc',
      fontSize: '18px',
      paddingLeft: '15px',
    }
    return (
      <div>
        <div style={{height:50}}>
          <input
            style={style}
            type='text'
            value={this.state.label}
            id={`${this.props.data_key}`}
            onChange={this.onChange}
          />
        </div>
        <div>
          {renderIf(this.state.touched_and_blank === true)(
            <HelpBlock key={this.props.data_key + '_select_awesomplete'} style={{color: 'red'}}>{this.props.field_label} is a required field.</HelpBlock>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/select_awesomplete.js